<template>
  <div class="full-height full-width is-flex is-justify-content-space-between">
    <div class="full-width register__left-block">
      <img
        src="@/assets/images/logo-inverted.svg"
        alt="Logo"
        class="register__left-block--logo"
      >
      <register-form class="register__left-block--content" />
    </div>
    <div class="
      is-align-items-center
      is-flex is-flex-direction-column
      is-justify-content-center
      register__right-block
    ">
      <div class="
        is-flex is-flex-direction-column
        is-justify-content-center
        register__right-block--main
      ">
        <img src="@/assets/images/register-right-1.svg" class="mb-6">
        <img src="@/assets/images/register-right-2.svg">
      </div>
      <img
        alt="Register Image"
        class="register__right-block--image"
        src="@/assets/images/register-image.svg"
      >
    </div>
  </div>
</template>

<script>
import Register from './Register';

export default Register;
</script>

<style lang="scss" scoped>
@import 'Register';
</style>
